import React from "react";
import StepIndicator from "./StepIndicator";

const CaseDetailsHeader = () => {
  return (
    <div style={styles.wrapper}>
      {/* <div style={styles.stepRow}>
        <StepIndicator stepNumber={1} lineWidth="200px" />
      </div> */}
<div className="mobile-step-indicator" style={{ width: "100%" }}>
  <div style={{ width: "100%", maxWidth: 420, height: 44, display: "flex", alignItems: "center" }}>
    <StepIndicator stepNumber={1} lineWidth="200px" />
  </div>
</div>

      <div style={styles.newCase}>New case</div>

      <div style={styles.caseDetails}>Case Details</div>
    </div>
  );
};

export default CaseDetailsHeader;

const styles = {
  wrapper: {
    width: "100%",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "16px",
    paddingBottom: "8px",
  },

  // gives StepIndicator a clean centered lane
  stepRow: {
    width: "100%",
    maxWidth: "420px", // adjust if you want longer lines
    paddingLeft: "16px",
    paddingRight: "16px",
    marginBottom: "8px",
  },

  newCase: {
    fontFamily:
      "Montserrat, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    fontWeight: 500,
    fontSize: "9px",
    lineHeight: "100%",
    letterSpacing: "0.1px",
    textAlign: "center",
    color: "#000000DE",
  },

  caseDetails: {
    marginTop: "6px",
    fontFamily:
      '"Barlow Condensed", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "75%",
    letterSpacing: "0.25px",
    textAlign: "center",
    color: "#000000DE",
  },
};
